export function blockImageTabs() {
    document.addEventListener('DOMContentLoaded', function () {

        const accordions = document.querySelectorAll('.blockImageTabs__accordion');
        const images = document.querySelectorAll('.blockImageTabs__image');

        if (!accordions.length) return;

        accordions[accordions.length - 1].classList.add('last');

        accordions.forEach(acc => {
            acc.addEventListener('click', function () {

                const target = this.getAttribute('data-image');
                const wasActive = this.classList.contains('active');

                accordions.forEach(a => a.classList.remove('active'));

                images.forEach(img => img.classList.remove('active'));

                if(!wasActive) this.classList.add('active')

                const matchedImage = document.querySelector(`.blockImageTabs__image[data-image="${target}"]`);

                if (matchedImage) {
                    matchedImage.classList.add('active');
                }
            });
        });

    });
}
